import React from 'react';
import { useNavigate } from 'react-router';
import { useAppSelector } from '@state';
import { IconButton } from '@chakra-ui/react';
import { LuLogOut } from 'react-icons/lu';
import { AuthsApi } from '@api';
import { actionExecution } from '@state/utils';
import { store } from '@state/store';
import { actions } from '../../../state/constants/appActions';
import {
  clearSelectedProject,
  clearSelectedProjectSheet,
  clearSelectedRelease,
} from '@/state/slices';
const Logout: React.FC<{}> = () => {
  const navigate = useNavigate();
  const { users, current } = useAppSelector((state) => state.auth);
  const [postLogout] = AuthsApi.Api.usePostAuthLogoutMutation();

  const handleLogout = async () => {
    if (current.userid) {
      const { data, error } = await postLogout(current.userid);

      await actionExecution({
        action: actions.logoutCurrent,
        dispatch: store.dispatch,
        args: {
          userid: current.userid,
        },
      });
    }

    const remainingUsers = Object.keys(users).filter(
      (userId) => Number(userId) !== current.userid,
    );
    const hasOtherUsers = remainingUsers.length > 0;

    // reset stale persisted data
    clearSelectedProject();
    clearSelectedRelease();
    clearSelectedProjectSheet();

    navigate('/login', { state: { isNew: !hasOtherUsers } });
  };

  return (
    <IconButton
      aria-label="logout"
      color="fg"
      variant={'plain'}
      onClick={handleLogout}
    >
      <LuLogOut />
    </IconButton>
  );
};

export default Logout;
